import { render } from "./RadioItem.vue?vue&type=template&id=5c0e5219"
import script from "./RadioItem.vue?vue&type=script&lang=js"
export * from "./RadioItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__